import React from 'react';

import { IconWrapper } from '@/components/ui/IconWrapper';
import type { AuthError } from '@/features/auth/shared/types/auth';
import { cn } from '@/utils/cn';
import { CloseCircleFilled } from '@ant-design/icons';

interface ErrorBannerProps {
  error: AuthError | null;
  className?: string;
}

export const ErrorBanner: React.FC<ErrorBannerProps> = ({ error, className }) => {
  if (!error) return null;

  return (
    <div
      className={cn(
        'text-typography-900 border-error-200 bg-error-100 flex min-h-9 w-81 items-center rounded-md border py-1 text-center text-sm transition-all duration-300',
        className
      )}
    >
      <IconWrapper icon={CloseCircleFilled} className="text-error-500 mt-px pr-2 pl-3 text-lg" /> {error.message}
    </div>
  );
};
